<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <!-- <ServerError v-if="ServerError" /> -->
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap justify-center v-if="sellers.grocerySellerId">
          <v-flex xs12 pb-lg-4 pb-5 v-if="sellers.grocerySellerId">
            <v-img
              width="100%"
              height="300px"
              :src="mediaURL + sellers.grocerySellerId.coverPhoto"
              class="align-center"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color=" #FDAC53"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs12 class="headds" text-center>
            <v-layout>
              <v-flex xs12 align-self-center text-center>
                <span style="font-size: 28px">
                  {{ sellers.grocerySellerId.shopName }}</span
                >
              </v-flex>
            </v-layout>
            <v-layout wrap justify-start>
              <v-flex xs12 sm4 md4 lg3 align-self-start pt-3 px-sm-2>
                <div v-viewer style="display: flex">
                  <img
                    style="object-fit: contain; cursor: pointer"
                    width="100%"
                    height="250px"
                    contain
                    :src="mediaURL + sellers.grocerySellerId.photo"
                  />
                </div>
              </v-flex>
              <v-flex xs12 sm8 md8 lg9 align-self-start pl-3 text-left>
                <v-layout wrap justify-start text-center>
                  <v-flex xs12 md6 lg6 align-self-start>
                    <v-layout wrap justify-start>
                      <v-flex xs12 align-self-center text-left>
                        <span class="RB medium2">Shop Details</span>
                      </v-flex>

                      <!-- <v-flex
                        text-left
                        align-self-center
                        v-if="sellers.grocerySellerId.is24x7"
                        class="clr"
                        ><span style="color: green; font-size: 16px"
                          ><b> 24x7 available</b></span
                        >
                      </v-flex> -->
                      <v-flex
                        xs12
                        text-left
                        style="font-family: poppinsregular; font-size: 16px"
                        class="clr"
                      >
                        {{ sellers.grocerySellerId.description }}
                      </v-flex>
                      <v-flex
                        v-if="sellers.grocerySellerId.parcelCharge > 0"
                        xs12
                        align-self-center
                        text-left
                      >
                        <span class="RR medium" style="font-size: 14px"
                          >Parcel Charge:
                        </span>
                        <span style="font-size: 18px">
                          Rs.{{ sellers.grocerySellerId.parcelCharge }}</span
                        >
                      </v-flex>
                      <v-flex xs12 align-self-center text-left>
                        <span style="font-size: 14px" class="RR medium"
                          >City:
                        </span>
                        <span style="font-size: 18px">
                          {{ sellers.grocerySellerId.city }}</span
                        >
                      </v-flex>
                      <v-flex xs12 align-self-center text-left>
                        <span style="font-size: 14px" class="RR medium"
                          >Pincode:
                        </span>
                        <span style="font-size: 18px">
                          {{ sellers.grocerySellerId.pincode }}</span
                        >
                      </v-flex>
                      <v-flex xs12 align-self-center text-left>
                        <span style="font-size: 14px" class="RR medium"
                          >Total Products Added:
                        </span>
                        <span style="font-size: 18px"> {{ totalCount }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex
                            xs12
                            align-self-center
                            text-left
                            v-if="
                              sellers.grocerySellerId.socialmedialinks
                                .hasupdated
                            "
                          >
                            <span class="RB medium2">Social Media Links</span>
                          </v-flex>
                          <v-flex xs12 pt-0 text-left>
                            <v-layout wrap justify-start>
                              <v-flex
                                lg2
                                sm2
                                v-if="
                                  sellers.grocerySellerId.socialmedialinks
                                    .twitter != ''
                                "
                              >
                                <a
                                  target="_blank"
                                  :href="
                                    sellers.grocerySellerId.socialmedialinks
                                      .twitter
                                  "
                                >
                                  <v-icon>mdi-twitter</v-icon>
                                </a>
                              </v-flex>
                              <v-flex
                                lg2
                                sm2
                                text-left
                                v-if="
                                  sellers.grocerySellerId.socialmedialinks
                                    .facebook != ''
                                "
                              >
                                <a
                                  target="_blank"
                                  :href="
                                    sellers.grocerySellerId.socialmedialinks
                                      .facebook
                                  "
                                >
                                  <v-icon>mdi-facebook</v-icon>
                                </a>
                              </v-flex>
                              <v-flex
                                lg2
                                sm2
                                text-left
                                v-if="
                                  sellers.grocerySellerId.socialmedialinks
                                    .whatsapp != ''
                                "
                              >
                                <a
                                  target="_blank"
                                  :href="
                                    'https://wa.me/' +
                                    sellers.grocerySellerId.socialmedialinks
                                      .whatsapp
                                  "
                                >
                                  <v-icon>mdi-whatsapp</v-icon>
                                </a>
                              </v-flex>
                              <v-flex
                                lg2
                                sm2
                                text-left
                                v-if="
                                  sellers.grocerySellerId.socialmedialinks
                                    .linkedin != ''
                                "
                              >
                                <a
                                  target="_blank"
                                  :href="
                                    sellers.grocerySellerId.socialmedialinks
                                      .linkedin
                                  "
                                >
                                  <v-icon>mdi-linkedin</v-icon>
                                </a>
                              </v-flex>
                              <v-flex
                                lg2
                                sm2
                                text-left
                                v-if="
                                  sellers.grocerySellerId.socialmedialinks
                                    .instagram != ''
                                "
                              >
                                <a
                                  :href="
                                    sellers.grocerySellerId.socialmedialinks
                                      .instagram
                                  "
                                >
                                  <v-icon>mdi-instagram</v-icon>
                                </a>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- <v-layout wrap justify-start>
                      <v-flex
                        v-if="sellers.status != 'Pending'"
                        xs6
                        sm6
                        py-2
                        text-left
                      >
                        <v-btn
                          color="warning"
                          :to="
                            '/AddGroceryProduct?sellerId=' +
                            this.$route.query.seller
                          "
                          small
                          outlined
                        >
                      

                          <span>Add Product </span></v-btn
                        >
                      </v-flex>
                      <v-flex xs6 sm6 py-2 text-left>
                        <span v-if="sellers.status == 'Inactive'">
                          <v-btn
                            color="green"
                            @click="statusDialog = true"
                            small
                            outlined
                            ><span>Enable Seller </span>
                          </v-btn>
                        </span>
                        <span v-if="sellers.status == 'Active'">
                          <v-btn
                            color="red"
                            @click="statusDialog = true"
                            small
                            outlined
                            ><span>Disable Seller </span>
                          </v-btn>
                        </span>
                      </v-flex>
                      <v-flex xs6 sm6 text-left py-2>
                        <v-btn
                          color="warning"
                          :to="
                            'editSeller?seller=' +
                            $route.query.seller +
                            '&Type=grocerySeller'
                          "
                          small
                          outlined
                          ><span>Edit Seller</span></v-btn
                        >
                      </v-flex>
                      <v-flex xs6 sm6 text-left py-2>
                        <v-btn
                          color="red"
                          @click="deleteDialog = true"
                          small
                          outlined
                          ><span>Remove Seller</span></v-btn
                        >
                      </v-flex>
                    </v-layout> -->
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-layout wrap justify-start>
                      <v-flex
                        v-if="sellers.status != 'Pending'"
                        xs6
                        sm6
                        py-2
                        text-left
                        pr-1
                      >
                        <v-btn
                          block
                          color="warning"
                          :to="
                            '/AddGroceryProduct?sellerId=' +
                            this.$route.query.seller
                          "
                          small
                          outlined
                        >
                          <!-- '/AddGroceryProduct?sellerId=' + this.$route.query.seller
                  " -->

                          <span>Add Product </span></v-btn
                        >
                      </v-flex>
                      <v-flex xs6 sm6 py-2 text-left pl-1 text-right>
                        <span v-if="sellers.status == 'Inactive'">
                          <v-btn
                            block
                            color="green"
                            @click="statusDialog = true"
                            small
                            outlined
                            ><span>Enable Seller </span>
                          </v-btn>
                        </span>
                        <span v-if="sellers.status == 'Active'">
                          <v-btn
                            block
                            color="red"
                            @click="statusDialog = true"
                            small
                            outlined
                            ><span>Disable Seller </span>
                          </v-btn>
                        </span>
                      </v-flex>
                      <v-flex xs6 sm6 text-left py-2 pr-1>
                        <v-btn
                          block
                          color="warning"
                          :to="
                            'editSeller?seller=' +
                            $route.query.seller +
                            '&Type=grocerySeller'
                          "
                          small
                          outlined
                          ><span>Edit Seller</span></v-btn
                        >
                      </v-flex>
                      <v-flex xs6 sm6 text-left py-2 text-right pl-1>
                        <v-btn
                          block
                          color="red"
                          @click="deleteDialog = true"
                          small
                          outlined
                          ><span>Remove Seller</span></v-btn
                        >
                      </v-flex>
                      <v-flex xs12>
                        <v-btn
                          style="color: white"
                          :to="'/Q&A?shop=' + sellers.grocerySellerId.shopName +'&id=' +this.$route.query.seller"
                          block
                          color="warning"
                          dark
                          small
                          ><span>Questions And Answers</span></v-btn
                        >
                      </v-flex>
                    </v-layout>

                    <!-- <v-layout wrap pt-2 justify-center>
                      <v-flex xs12 pb-2>
                        <span
                          v-if="hours.length > 0"
                          style="font-size: 18px"
                          class="headds"
                          >Working Hours</span
                        >
                      </v-flex>
                      <v-flex xs12 lg12 px-2>
                        <v-card
                          flat
                          color="#FAFAFA"
                          style="font-family: poppinsbold"
                          v-if="hours.length > 0"
                          class="py-3"
                        >
                          <v-layout
                            wrap
                            justify-center
                            v-for="(item, i) in hours"
                            :key="i"
                          >
                            <v-flex xs4 lg3>
                              <span style="font-size: 14px">{{
                                hours[i].day
                              }}</span>
                            </v-flex>
                            <v-flex xs4 lg3 v-if="hours[i].open == null">
                              <span style="font-size: 14px; color: red">
                                Closed</span
                              >
                            </v-flex>
                            <v-flex xs4 lg3 v-else>
                              <span style="font-size: 14px">{{
                                tConvert(hours[i].open)
                              }}</span>
                            </v-flex>
                            <v-flex xs4 lg3 v-if="hours[i].close == null">
                              <span style="font-size: 14px; color: red">
                                Closed</span
                              >
                            </v-flex>
                            <v-flex xs4 lg3 v-else>
                              <span style="font-size: 14px">{{
                                tConvert(hours[i].close)
                              }}</span>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout> -->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex py-3 xs12 text-center>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 py-3 v-if="sellers.grocerySellerId.category">
            <v-layout wrap py-4>
              <v-flex xs12 align-self-center text-center pb-8>
                <span class="headds">Selling Category</span>
              </v-flex>
              <v-flex
                xs12
                align-self-center
                lg3
                pt-3
                px-2
                v-for="(items, i) in sellers.grocerySellerId.category"
                :key="i"
              >
                <v-card
                  flat
                  elevation="2"
                  @click="
                    $router.push(
                      'shopProducts?category=' +
                        items._id +
                        '&seller=' +
                        $route.query.seller +
                        '&shop=' +
                        sellers.grocerySellerId.shopName
                    )
                  "
                >
                  <v-layout wrap justify-start>
                    <v-flex xs3 align-self-center text-center>
                      <v-list-item-avatar>
                        <v-img contain :src="mediaURL + items.icon"></v-img>
                      </v-list-item-avatar>
                    </v-flex>
                    <v-flex xs9 align-self-center text-left>
                      <span style="font-family: poppinsmedium">{{
                        items.name
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 text-center>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 pt-3 pb-6 v-if="sellers.grocerySellerId.type">
            <v-layout wrap py-4>
              <v-flex xs12 align-self-center text-center>
                <span class="headds">Product Types</span>
              </v-flex>
              <v-flex
                xs12
                align-self-center
                lg3
                pt-4
                px-2
                v-for="(items, i) in sellers.grocerySellerId.type"
                :key="i"
              >
                <v-card
                  @click="
                    $router.push(
                      'shopProducts?productType=' +
                        items +
                        '&seller=' +
                        $route.query.seller +
                        '&shop=' +
                        sellers.grocerySellerId.shopName
                    )
                  "
                  flat
                  elevation="2"
                >
                  <v-layout pa-4 wrap justify-center>
                    <v-flex xs12 align-self-center text-center>
                      <!-- <v-list-item-avatar>
                      <v-img contain :src="mediaURL + items.icon"></v-img>
                    </v-list-item-avatar> -->
                      <span style="font-family: poppinsmedium">{{
                        items
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 text-center>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 pb-8>
            <v-layout wrap>
              <v-flex xs12 align-self-center text-center py-6>
                <span class="headds">Products </span>
              </v-flex>
              <v-flex xs12 md12 v-if="products">
                <v-layout wrap pb-3>
                  <v-flex xs6 sm6 md3 v-for="(item, i) in products" :key="i">
                    <v-card
                      flat
                      :elevation="0.1"
                      :to="
                        'groceryProductInfo?id=' +
                        item._id +
                        '&seller=' +
                        $route.query.seller +
                        '&shop=' +
                        sellers.grocerySellerId.shopName
                      "
                    >
                      <v-layout wrap justify-center text-center py-5 px-3>
                        <v-flex xs12 pb-2 v-if="item.photo">
                          <v-img
                            height="200"
                            contain
                            :src="mediaURL + item.photo"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color=" #FDAC53"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-flex>
                        <v-flex xs12 pb-2 v-else>
                          <v-img
                            height="150"
                            contain
                            :src="require('../../assets/images/no-image.png')"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color=" #FDAC53"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-flex>
                        <v-flex xs12 text-center pt-2>
                          <v-layout wrap justify-center>
                            <v-card flat height="30%">
                              <v-flex style="font-family: poppinsbold" xs12>
                                {{ item.productId.name }}
                              </v-flex>

                              <v-flex xs12 pt-1 v-if="item.discount > 0">
                                <span style="font-weight: bold">
                                  Rs. {{ item.offerPrice }}
                                </span>
                                <del
                                  ><span style="font-weight: bold">
                                    Rs. {{ item.price }}
                                  </span></del
                                >
                              </v-flex>
                              <v-flex xs12 pt-1 v-else>
                                <span style="font-weight: bold">
                                  Rs. {{ item.offerPrice }}
                                </span>
                              </v-flex>
                            </v-card>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-else>
                <span class="">No Products!!!</span>
              </v-flex>
              <v-flex xs12 text-center py-8 px-2 v-if="totalCount > 0">
                <v-btn
                  tile
                  outlined
                  :to="
                    'shopProducts?seller=' +
                    $route.query.seller +
                    '&shop=' +
                    sellers.grocerySellerId.shopName
                  "
                >
                  <span class="RB">VIEW ALL PRODUCTS</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- End Product  -->
          <v-flex xs12 md12 px-lg-5 pb-12 px-2 text-left>
            <v-card color="#FAFAFA" tile>
              <v-layout wrap px-3 py-4 pa-sm-12 justify-start>
                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12 align-self-center>
                      <span style="font-family: poppinsbold"
                        >Shop Owner Details</span
                      >
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span><v-icon>mdi-account-outline</v-icon></span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.grocerySellerId.contactPerson
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2>
                      <span><v-icon>mdi-phone-outline</v-icon></span>
                      <span class="RR" style="margin-left: 1%">{{
                        sellers.phone
                      }}</span>
                      <!-- <span class="RR" style="margin-left: 3%"
                        >+91 4839 333 333</span
                      > -->
                    </v-flex>
                    <v-flex xs12 py-2>
                      <span><v-icon>mdi-at</v-icon></span>
                      <span class="RR" style="margin-left: 1%">{{
                        sellers.grocerySellerId.email
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2>
                      <span><v-icon>mdi-map-marker-outline</v-icon></span>
                      <span class="RR" style="margin-left: 1%"
                        >{{ sellers.grocerySellerId.city }},
                        {{ sellers.grocerySellerId.place }}</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12 align-self-center>
                      <span style="font-family: poppinsbold">Bank Details</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Account Holder :</b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.grocerySellerId.bankDetails.accountHolder
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Account Number : </b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.grocerySellerId.bankDetails.accountNo
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Bank : </b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.grocerySellerId.bankDetails.bank
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> Branch : </b></span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.grocerySellerId.bankDetails.branch
                      }}</span>
                    </v-flex>
                    <v-flex xs12 py-2 text-left>
                      <span class="RR"><b> IFSC :</b> </span
                      ><span style="margin-left: 1%" class="RR">{{
                        sellers.grocerySellerId.bankDetails.ifsc
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs12
                  align-self-center
                  v-if="sellers.grocerySellerId.documents"
                >
                  <v-layout wrap justify-start>
                    <v-flex xs12 lg6 align-self-center text-left>
                      <span style="font-family: poppinsbold">Documents</span>
                    </v-flex>
                    <v-flex xs12 align-self-center text-left>
                      <v-layout wrap justify-start>
                        <v-flex
                          xs12
                          lg3
                          pa-2
                          v-for="(doc, k) in sellers.grocerySellerId.documents"
                          :key="k"
                        >
                          <template v-if="doc.split('.').pop() !== 'pdf'">
                            <div v-viewer style="display: flex">
                              <img
                                style="object-fit: contain; cursor: pointer"
                                :style="
                                  $vuetify.breakpoint.name == 'xs'
                                    ? 'height:100px'
                                    : 'height:150px'
                                "
                                :src="mediaURL + doc"
                              />
                            </div>
                          </template>
                          <template v-else>
                            <a :href="mediaURLOld + doc" target="_blank"></a>
                          </template>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-divider></v-divider>
          <v-flex xs12 align-self-center v-if="sellers.status == 'Pending'">
            <v-layout wrap justify-center pa-4>
              <v-flex xs6 sm4 md3 lg2 px-2 text-left>
                <v-btn
                  width="100%"
                  small
                  color="primary"
                  @click="verifyStatus('approve')"
                  >APPROVE</v-btn
                >
              </v-flex>
              <v-flex xs6 sm4 md3 lg2 px-2 text-right>
                <v-btn
                  small
                  width="100%"
                  color="error"
                  @click="verifyStatus('reject')"
                  >REJECT</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 py-3>
        <span class="headds">Shop Location</span>
      </v-flex>
      <v-flex xs12>
        <div id="map"></div>
      </v-flex>
    </v-layout>
    <!-- <ExtraDetails/> -->

    <v-dialog v-model="statusDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title v-if="sellers.status == 'Active'"
          >Are you sure you want to disable this Seller.?</v-card-title
        >
        <v-card-title v-if="sellers.status == 'Inactive'"
          >Are you sure you want to enable this Seller?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="verifyDelete" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#ffffff" v-on="on" v-bind="attrs">mdi-delete</v-icon>
      </template>
      <v-card class="pa-5">
        <v-layout wrap>
          <v-flex xs12>
            <span style="font-size: 20px; font-weight: bold">{{ notice }}</span>
          </v-flex>
          <v-flex xs12 pt-3>
            <v-layout wrap>
              <v-flex xs12 v-if="isReject" pa-4>
                <v-form v-model="validates" ref="form">
                  <span style="font-size: 12px">Please enter the remarks</span>

                  <v-textarea
                    color="warning"
                    outlined
                    name="input-7-4"
                    v-model="reason"
                    :rules="[req.required]"
                    label="Enter the remarks"
                  ></v-textarea>
                </v-form>
              </v-flex>
              <v-flex xs12 text-left v-else>
                <v-form v-model="validates1" ref="form">
                  <span style="font-size: 12px"
                    >Please enter the parcel charge</span
                  >
                  <v-text-field
                    outlined
                    v-model="parcelCharge"
                    label="Parcel Charge"
                    placeholder="Enter the parcel charge"
                    :rules="[req.required]"
                  ></v-text-field>
                </v-form>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-btn
              color="error"
              text
              @click="(verifyDelete = false), (isReject = false), (reason = '')"
              >Cancel</v-btn
            >
            <v-btn
              :disabled="(!validates && isReject) || (!validates1 && !isReject)"
              color="primary"
              text
              @click="updateStatus(keepStatus)"
              >OK</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title>Are you sure you want to remove this seller</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- verify  -->

    <!-- <v-dialog v-model="verifyDelete" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="#ffffff" v-on="on" v-bind="attrs">mdi-delete</v-icon>
      </template>
      <v-card>
        <v-card-title>{{ notice }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="verifyDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" text @click="updateStatus(keepStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>


<script
 src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBaUVPtkwXGFXPy05pSXVx0Y7QmGj-P-ls&callback=initMap&libraries=&v=weekly"
      async>
</script>
<script>
// import ImageLoader from "@/components/Common/imageLoader";
// import ExtraDetails  from ".A";

import axios from "axios";
export default {
  components: {
    // ExtraDetails,
  },
  data() {
    return {
      currentPage: 1,
      sellers: [],
      hours: [],
      products: [],
      totalCount: 0,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      splitUrl: "",
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 4, nav: false },
      },
      mapData: [],
      latt: null,
      lonn: null,
      map3: null,
      marker: [],
      verifyDelete: false,
      keepStatus: "",
      notice: "",
      isReject: false,
      validates: false,
      validates1: false,
      parcelCharge: 0,
      reason: "",
      req: {
        required: (value) => !!value || "Required.",
      },
      marker: [],
      msg: "",
      latt: 0,
      lonn: 0,
      maps: null,
      flag: false,
      statusDialog: false,
      deleteDialog: false,
    };
  },
  components: {
    // ImageLoader,
  },
  watch: {
    currentPage() {
      // this.getData();
      this.getProduct();
    },
  },
  beforeMount() {
    if (this.$route.query.seller) {
      this.getData();
      this.getProduct();
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    tConvert(time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join("");

      // return adjusted time or original string
    },

    // converting time
    initMap() {
      this.map3 = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 22.5937, lng: 78.96 },
        zoom: 9,
        mapTypeId: google.maps.MapTypeId.HYBRID,
      });
    },
    mark(event) {
      console.log("eve", event);
      this.latt = null;
      this.lonn = null;
      this.marker.setMap(null);
      this.latt = event.latLng.lat();
      this.lonn = event.latLng.lng();
      this.marker = new google.maps.Marker({
        position: { lat: this.latt, lng: this.lonn },
        map: this.maps,
        title: "Hello World!",
      });
      console.log("marker =", this.latt);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.sellers = response.data.data;
            this.hours = response.data.data.grocerySellerId.workingHour;
            // console.log("work", this.hours)
            this.latt = this.sellers.grocerySellerId.location[1];
            this.lonn = this.sellers.grocerySellerId.location[0];
            // console.log(this.lonn);
            this.map3 = new google.maps.Map(document.getElementById("map"), {
              center: { lat: this.latt, lng: this.lonn },
              zoom: 18,
              mapTypeId: google.maps.MapTypeId.HYBRID,
              // tilt: 170
            });

            this.marker = new google.maps.Marker({
              position: { lat: this.latt, lng: this.lonn },
              map: this.map3,
            });
            this.pages = response.data.pages;
            // this.excel = response.data.data;

            // this.json_data = this.excel;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProduct() {
      this.appLoading = true;
      // axios({
      //   method: "POST",
      //   url: "/admin/seller/product/list",
      //   headers: {
      //     token: localStorage.getItem("token"),
      //   },
      //   data: {
      //     userid: this.$route.query.seller,
      //     page: 1,
      //     limit: 8,
      //   },
      // })

      axios({
        method: "POST",
        url: "/grocery/admin/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: {
          sellerId: this.$route.query.seller,
          page: this.currentPage,
          limit: 50,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.totalCount = response.data.totalLength;
            if (this.totalCount > 8)
              this.products = response.data.product.slice(0, 8);
            else this.products = response.data.product;

            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    changeStatus() {
      this.loading = true;
      axios({
        method: "POST",
        url: "/grocery/seller/status/change",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          sellerId: this.$route.query.seller,
        },
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.getData();
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    verifyStatus(status) {
      this.verifyDelete = true;
      this.keepStatus = status;
      if (status == "approve")
        this.notice = "Do you want to approve this request?";
      else if (status == "reject") {
        this.isReject = true;
        this.notice = "Do you want to reject this request?";
      }
    },
    updateStatus(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/grocery/user/approve/reject",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.seller,
          action: status,
          remark: this.reason,
          parcelCharge: this.parcelCharge,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.getData();
            this.verifyDelete = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    cutVideo(eve) {
      let b = "https://www.youtube.com/embed/";
      // this.programs.video[0]
      // this.splitUrl(eve.replace("https://youtu.be/", embed));
      var em = eve.replace("https://youtu.be/", b);
      this.splitUrl = em;
      // console.log(this.splitUrl);
    },
    deleteItem() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/delete/",
        data: {
          id: this.$route.query.seller,
          // id: "6681c028d6edebcf92ce4c500d",
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$router.push("/sellerlist");
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.$router.push("/sellerlist");

            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.deleteDialog = false;
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.$router.push("/sellerlist");
        });
    },
  },
};
</script>

<style  scoped>
#map {
  height: 400px;
  /* The height is 400 pixels */
  width: 100%;
  /* The width is the width of the web page */
}
</style>